/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportStationTickets } from '../fn/ticketing/export-station-tickets';
import { ExportStationTickets$Params } from '../fn/ticketing/export-station-tickets';
import { exportTickets } from '../fn/ticketing/export-tickets';
import { ExportTickets$Params } from '../fn/ticketing/export-tickets';
import { forceCloseTicket } from '../fn/ticketing/force-close-ticket';
import { ForceCloseTicket$Params } from '../fn/ticketing/force-close-ticket';
import { getTicket } from '../fn/ticketing/get-ticket';
import { GetTicket$Params } from '../fn/ticketing/get-ticket';
import { searchStationTickets$Any } from '../fn/ticketing/search-station-tickets-any';
import { SearchStationTickets$Any$Params } from '../fn/ticketing/search-station-tickets-any';
import { searchStationTickets$Json } from '../fn/ticketing/search-station-tickets-json';
import { SearchStationTickets$Json$Params } from '../fn/ticketing/search-station-tickets-json';
import { searchTickets$Any } from '../fn/ticketing/search-tickets-any';
import { SearchTickets$Any$Params } from '../fn/ticketing/search-tickets-any';
import { searchTickets$Json } from '../fn/ticketing/search-tickets-json';
import { SearchTickets$Json$Params } from '../fn/ticketing/search-tickets-json';
import { Ticket } from '../models/ticket';
import { ticketAddComment } from '../fn/ticketing/ticket-add-comment';
import { TicketAddComment$Params } from '../fn/ticketing/ticket-add-comment';
import { ticketEstimate } from '../fn/ticketing/ticket-estimate';
import { TicketEstimate$Params } from '../fn/ticketing/ticket-estimate';
import { TicketPagedList } from '../models/ticket-paged-list';
import { ticketTransfer } from '../fn/ticketing/ticket-transfer';
import { TicketTransfer$Params } from '../fn/ticketing/ticket-transfer';


/**
 * All about the incident tickets
 */
@Injectable({ providedIn: 'root' })
export class TicketingService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchStationTickets()` */
  static readonly SearchStationTicketsPath = '/stations/{uid}/tickets/search';

  /**
   * search tickets for a given station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTickets$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTickets$Json$Response(params: SearchStationTickets$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketPagedList>> {
    return searchStationTickets$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search tickets for a given station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTickets$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchStationTickets$Json(params: SearchStationTickets$Json$Params, context?: HttpContext): Observable<TicketPagedList> {
    return this.searchStationTickets$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketPagedList>): TicketPagedList => r.body)
    );
  }

  /**
   * search tickets for a given station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchStationTickets$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTickets$Any$Response(params: SearchStationTickets$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketPagedList>> {
    return searchStationTickets$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search tickets for a given station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchStationTickets$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchStationTickets$Any(params: SearchStationTickets$Any$Params, context?: HttpContext): Observable<TicketPagedList> {
    return this.searchStationTickets$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketPagedList>): TicketPagedList => r.body)
    );
  }

  /** Path part for operation `exportStationTickets()` */
  static readonly ExportStationTicketsPath = '/stations/{uid}/tickets/export';

  /**
   * Export in Excel the tickets of a station.
   *
   * Export in Excel the tickets of a station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTickets$Response(params: ExportStationTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * Export in Excel the tickets of a station.
   *
   * Export in Excel the tickets of a station, in a given interval, and sorted on a given field and direction
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTickets(params: ExportStationTickets$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `searchTickets()` */
  static readonly SearchTicketsPath = '/tickets/search';

  /**
   * search tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTickets$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTickets$Json$Response(params?: SearchTickets$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketPagedList>> {
    return searchTickets$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * search tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTickets$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTickets$Json(params?: SearchTickets$Json$Params, context?: HttpContext): Observable<TicketPagedList> {
    return this.searchTickets$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketPagedList>): TicketPagedList => r.body)
    );
  }

  /**
   * search tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTickets$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTickets$Any$Response(params?: SearchTickets$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketPagedList>> {
    return searchTickets$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTickets$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchTickets$Any(params?: SearchTickets$Any$Params, context?: HttpContext): Observable<TicketPagedList> {
    return this.searchTickets$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<TicketPagedList>): TicketPagedList => r.body)
    );
  }

  /** Path part for operation `exportTickets()` */
  static readonly ExportTicketsPath = '/tickets/export';

  /**
   * Export in Excel the tickets.
   *
   * Export in Excel the tickets, in a given interval, and sorted on a given field and direction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportTickets()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTickets$Response(params?: ExportTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * Export in Excel the tickets.
   *
   * Export in Excel the tickets, in a given interval, and sorted on a given field and direction
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportTickets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportTickets(params?: ExportTickets$Params, context?: HttpContext): Observable<Blob> {
    return this.exportTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getTicket()` */
  static readonly GetTicketPath = '/tickets/{uid}';

  /**
   * get a ticket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTicket()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicket$Response(params: GetTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
    return getTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * get a ticket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTicket$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTicket(params: GetTicket$Params, context?: HttpContext): Observable<Ticket> {
    return this.getTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<Ticket>): Ticket => r.body)
    );
  }

  /** Path part for operation `ticketAddComment()` */
  static readonly TicketAddCommentPath = '/tickets/{uid}/comment';

  /**
   * Add comment to a ticket.
   *
   * Add a comment to a ticket
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketAddComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketAddComment$Response(params: TicketAddComment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketAddComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Add comment to a ticket.
   *
   * Add a comment to a ticket
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketAddComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketAddComment(params: TicketAddComment$Params, context?: HttpContext): Observable<void> {
    return this.ticketAddComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ticketTransfer()` */
  static readonly TicketTransferPath = '/tickets/{uid}/transfer';

  /**
   * Transfer a ticket to another diffusion list user.
   *
   * Transfer a ticket to another diffusion list user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketTransfer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketTransfer$Response(params: TicketTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketTransfer(this.http, this.rootUrl, params, context);
  }

  /**
   * Transfer a ticket to another diffusion list user.
   *
   * Transfer a ticket to another diffusion list user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketTransfer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketTransfer(params: TicketTransfer$Params, context?: HttpContext): Observable<void> {
    return this.ticketTransfer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `ticketEstimate()` */
  static readonly TicketEstimatePath = '/tickets/{uid}/estimate';

  /**
   * Estimate a duration of start intervention about a ticket.
   *
   * Estimate a duration of start intervention about a ticket
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ticketEstimate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketEstimate$Response(params: TicketEstimate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ticketEstimate(this.http, this.rootUrl, params, context);
  }

  /**
   * Estimate a duration of start intervention about a ticket.
   *
   * Estimate a duration of start intervention about a ticket
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ticketEstimate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ticketEstimate(params: TicketEstimate$Params, context?: HttpContext): Observable<void> {
    return this.ticketEstimate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `forceCloseTicket()` */
  static readonly ForceCloseTicketPath = '/tickets/{uid}/force-close';

  /**
   * Force close this ticket, only for ADMIN.
   *
   * Force close this ticket, only for ADMIN
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `forceCloseTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forceCloseTicket$Response(params: ForceCloseTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return forceCloseTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * Force close this ticket, only for ADMIN.
   *
   * Force close this ticket, only for ADMIN
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `forceCloseTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  forceCloseTicket(params: ForceCloseTicket$Params, context?: HttpContext): Observable<void> {
    return this.forceCloseTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
